module.exports = __webpack_public_path__ + "img/st-icon-3-1.5bb865d4.png";